import { SessionController } from '@/controllers';

import { getInstance } from './index';
import store from '../store';

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    if (authService.isAuthenticated) {
      try {
        if (!localStorage.getItem('login-token')) {
          const accessToken = await authService.getTokenSilently();
          await store.dispatch('session/auth0Authenticate', accessToken);
        } else {
          const response = await SessionController.verifyToken(localStorage.getItem('login-token'));
          if (response.status === 403) {
            const accessToken = await authService.getTokenSilently();
            await store.dispatch('session/auth0Authenticate', accessToken);
          }
        }
        return next();
      } catch (e) {
        localStorage.removeItem('login-token');
      }
    }
    // authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    return next('/auth');
  };
  // If loading has already finished, check the auth state using `fn()`
  if (!authService.loading) {
    return fn();
  }

  // Watch for the loading property to change before checking isAuthenticated
  authService.$watch('loading', (loading) => {
    if (loading === false) {
      return fn();
    }
  });
};
